var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98865 13.0067C10.4205 13.5847 10.9716 14.0629 11.6043 14.4089C12.2371 14.755 12.9368 14.9608 13.656 15.0123C14.3752 15.0639 15.0971 14.96 15.7726 14.7078C16.4482 14.4555 17.0617 14.0608 17.5714 13.5503L20.5885 10.5302C21.5044 9.58092 22.0113 8.30946 21.9998 6.9897C21.9884 5.66995 21.4595 4.4075 20.5272 3.47426C19.5949 2.54102 18.3337 2.01166 17.0153 2.00019C15.6969 1.98872 14.4267 2.49606 13.4783 3.41295L11.7486 5.13438M14.0114 10.9933C13.5795 10.4153 13.0284 9.93711 12.3957 9.59105C11.7629 9.245 11.0632 9.03921 10.344 8.98765C9.6248 8.93609 8.90293 9.03997 8.22736 9.29223C7.55179 9.54449 6.93832 9.93924 6.42855 10.4497L3.41153 13.4698C2.49557 14.4191 1.98873 15.6905 2.00019 17.0103C2.01165 18.33 2.54048 19.5925 3.47278 20.5257C4.40508 21.459 5.66626 21.9883 6.98469 21.9998C8.30311 22.0113 9.57329 21.5039 10.5217 20.5871L12.2414 18.8656",
    stroke: "#282B59",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.05ea98b9011f17af797efcef54ce86cc.svg";
export { ForwardRef as ReactComponent };